import { UPDATE_MULTI_FACET } from "../constants";
import { analyticsAddPendingRefinementsToggled } from "../../analytics/actions";
import { applyFacets } from "../";
import {
  clearAlwaysApply as clearAlwaysApplyAction,
  dismissFloorDeselections
} from "../actions";
import { isLargeMediumViewPort } from "../viewportHelper";

export const changeMultiFacet = toggledFacets => (dispatch, getState) => {
  const normalized = toggledFacets.map(({ facet, facetValue, isSelected }) => ({
    facetId: facet.id,
    valueId: facetValue.id,
    isSelected
  }));

  const state = getState();
  const isMobile = !isLargeMediumViewPort(state);

  dismissFloorDeselections(dispatch, normalized);

  dispatch({
    type: UPDATE_MULTI_FACET,
    payload: normalized,
    meta: {
      originalToggles: toggledFacets,
      skipDebounce: isMobile
    }
  });

  dispatch(analyticsAddPendingRefinementsToggled(toggledFacets));

  if (isMobile) {
    dispatch(applyFacets());
  }
};

export const clearAlwaysApply = facetId => dispatch => {
  dispatch(clearAlwaysApplyAction(facetId));
};
